import React from 'react';
import { ChevronDown } from 'lucide-react';
import { heroData } from '../mock';

export const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', overflow: 'hidden' }}>
      {/* Background Video */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          zIndex: 0
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.7
          }}
        >
          <source src="https://customer-assets.emergentagent.com/job_yftgroup/artifacts/xyh76enf_Flow%20SceneBuilder%20Adverts%20Nov%2010%202025.mp4" type="video/mp4" />
        </video>
        {/* Dark overlay for better text readability */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.6)',
            zIndex: 1
          }}
        />
      </div>

      <div className="container hero-section" style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="hero-large fade-in visible" style={{ marginBottom: '24px', animation: 'fadeIn 1s ease-out', color: '#ffffff' }}>{heroData.headline}</h1>
          <p className="body-large" style={{ marginBottom: '48px', maxWidth: '700px', margin: '0 auto 48px', color: '#ffffff', animation: 'fadeIn 1s ease-out 0.2s backwards' }}>{heroData.subline}</p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap', animation: 'fadeIn 1s ease-out 0.4s backwards' }}>
            {heroData.buttons.map((button, index) => (
              <a key={index} href={button.link} onClick={(e) => scrollToSection(e, button.link)} className={button.type === 'primary' ? 'btn-primary button-text' : 'btn-secondary button-text'}>{button.text}</a>
            ))}
          </div>
        </div>
      </div>

      <div style={{ position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', cursor: 'pointer', animation: 'bounce 2s infinite' }} onClick={(e) => scrollToSection(e, '#legacy')}>
        <span className="body-small" style={{ color: 'var(--text-secondary)' }}>Scroll to explore</span>
        <ChevronDown size={20} color="var(--accent-gold)" />
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes bounce { 0%, 100% { transform: translateX(-50%) translateY(0); } 50% { transform: translateX(-50%) translateY(-10px); } }
      `}</style>
    </section>
  );
};